import { aboutData } from '@/mocks/niuniuData';

export default function HeroSection() {
  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=warm%20golden%20cinema%20theater%20interior%20with%20velvet%20red%20curtains%20and%20soft%20stage%20lighting%2C%20elegant%20movie%20palace%20atmosphere%2C%20rich%20textures%2C%20dramatic%20yet%20inviting%20ambiance%2C%20deep%20warm%20tones%2C%20no%20people%2C%20cinematic%20composition&width=1600&height=900&seq=hero-bg-cinema&orientation=landscape"
          alt="牛牛影视影院风格背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 max-w-[1200px] mx-auto w-full">
          <div className="flex-1 text-center lg:text-left w-full">
            <div className="inline-flex items-center gap-2 bg-primary-500/20 backdrop-blur-sm border border-primary-400/30 rounded-full px-4 py-1.5 mb-5">
              <span className="w-2 h-2 rounded-full bg-primary-400 animate-pulse"></span>
              <span className="text-xs md:text-sm text-primary-300 font-medium whitespace-nowrap">每日更新 · 全站免费</span>
            </div>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white leading-tight mb-4">
              牛牛影视 · 免费高清影视聚合平台
            </h1>

            <p className="text-lg md:text-xl text-white/80 font-heading mb-5">
              好内容，值得被更多人看见
            </p>

            <div className="text-sm md:text-base text-white/70 leading-relaxed max-w-xl mx-auto lg:mx-0 space-y-3 mb-7">
              <p>
                牛牛影视汇集电影大全、电视剧全集、热门综艺与高分动漫，全站免费无需付费。每日更新最新资源，
                多线路智能调度保障高清流畅播放，打造一站式免费影视聚合入口。
              </p>
              <p>
                从院线新片到经典老片，从国产剧到海外剧，无论你是科幻迷、悬疑控还是追剧达人，
                这里都有属于你的专属片单。当前正在热播《流浪地球3》《庆余年3》《封神第二部》等年度大作。
              </p>
            </div>

            <div className="flex flex-wrap justify-center lg:justify-start gap-4 md:gap-6 mb-7">
              {aboutData.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-bold text-primary-400">{stat.value}</div>
                  <div className="text-xs text-white/50">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row justify-center lg:justify-start gap-3">
              <a
                href="#carousel"
                className="inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-white font-medium px-6 py-3 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line text-lg"></i>
                热门推荐
              </a>
              <a
                href="#app"
                className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white font-medium px-6 py-3 rounded-lg border border-white/20 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-download-2-line text-lg"></i>
                下载 App
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=Chinese%20cinematic%20movie%20poster%20collage%20with%20warm%20golden%20and%20red%20tones%2C%20dramatic%20lighting%2C%20featuring%20sci-fi%20and%20fantasy%20elements%20like%20spaceships%20and%20ancient%20Chinese%20architecture%2C%20film%20strip%20borders%2C%20vintage%20cinema%20aesthetic%2C%20elegant%20composition%2C%20rich%20textures&width=900&height=1200&seq=hero-poster&orientation=portrait"
                alt="牛牛影视热门影片主题视觉"
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}